import { render, staticRenderFns } from "./SearchFilterSaveFiltersForm.vue?vue&type=template&id=64a501f6&scoped=true"
import script from "./SearchFilterSaveFiltersForm.vue?vue&type=script&lang=js"
export * from "./SearchFilterSaveFiltersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a501f6",
  null
  
)

export default component.exports